import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SousCategorieService } from 'app/services/sous-categorie/sous-categorie.service';

@Component({
  selector: 'app-liste-sous-categorie',
  templateUrl: './liste-sous-categorie.component.html',
  styleUrls: ['./liste-sous-categorie.component.scss']
})
export class ListeSousCategorieComponent implements OnInit {
  dataSource = new MatTableDataSource();
  public search: string  = ''

   sousCategorieProduit : any
  constructor(private sousCategorie:SousCategorieService) { }

  getData() {
    this.sousCategorie.getListSousCategorie().subscribe((data) => {
      this.sousCategorieProduit = data;
    });
    
  }
  ngOnInit() {
    this.sousCategorie.refreshNedeed.subscribe(() => this.getData());
    this.getData()
  }

  deleteSousCategorie(SousCategorieProduit: any) {
    this.sousCategorie.deleteSousCategorie(SousCategorieProduit.id).subscribe((response: any) => {


      console.log(this.dataSource.data);


    });
    setTimeout(() => {
      this.getData()
    }, 500)

  }
}
